import { NavLink } from "react-router-dom";
import logo from "../assets/logolime.jpg"

const linkClass = ({ isActive }) => `nav-link ${isActive ? "active" : ""}`;

export default function Header() {
    return (
        <header className="header">
            <div className="container header-inner">
                <div className="brand">
                    <img src={logo} alt="logo image" className="logo" aria-hidden />
                    <span className="brand-name">LimeTime</span>
                </div>

                <nav className="nav">
                    <a className={linkClass} href="https://www.limeti.me/">Home</a>
                    <a href="https://www.limeti.me/#Why-Choose" className={linkClass}>Why Choose us</a>
                    <a href="https://www.limeti.me/#integrations" className={linkClass}>About Us</a>
                    <a href="https://www.limeti.me/contact-us" className={linkClass} to="/contact">Contact us</a>
                </nav>

                <NavLink 
                    to="/request-demo" 
                    className="btn btn-primary"
                    style={{
                        borderRadius: "20px",
                        padding: "10px",
                        background: "#7bb321",
                        border: "none"
                    }}
                >
                    Request a Demo
                </NavLink>
            </div>
            <div className="demo-header mt-2">
                <h2 className="demo-subtitle">Request a Demo</h2>
                <h2 className="demo-title">
                    Sign up for a 14-day free trial and start managing Employee, LimeTime quotes, and growing your business with ease.
                </h2>
            </div>
        </header>
    );
}
